class AddFreeProduct {
  constructor() {
    this.variantId = window.freeProduct?.variantID;
    this.threshold = (window.freeProduct?.threshold || 0) * 100;
    this.isProcessing = false;
    this.init();
  }

  async fetchCart() {
    const res = await fetch('/cart.js');
    return await res.json();
  }

  calculateEligibleTotal(cart) {
    let total = 0;
    cart.items.forEach(item => {
      const isFreeGift = 
        (item.variant_id === this.variantId && item.properties?._free_gift) ||
        item.properties?._free_gift === 'true' ||
        item.properties?._free_gift === true;
      
      if (!isFreeGift) {
        total += item.final_line_price;
      }
    });
    return total;
  }

  async addProduct() {
    if (this.isProcessing) return;
    this.isProcessing = true;

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: this.variantId,
            quantity: 1,
            properties: {
              _free_gift: true,
              _variantId: this.variantId
            }
          }]
        })
      });

      console.log('Free gift added');
      this.instantRefresh();
    } catch (err) {
      console.error('Error adding:', err);
    } finally {
      this.isProcessing = false;
    }
  }

  async removeProduct(variantKey) {
    if (this.isProcessing) return;
    this.isProcessing = true;

    try {
      // FASTEST METHOD: Direct cart update
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: { [variantKey]: 0 }
        })
      });

      console.log(' Free gift removed');
      this.instantRefresh();
    } catch (err) {
      console.error('Error removing:', err);
    } finally {
      this.isProcessing = false;
    }
  }

  instantRefresh() {
    // Fire all refresh methods immediately
    if (typeof window.rerenderCart === 'function') {
      window.rerenderCart();
    }
    
    // Trigger all possible cart events
    const events = ['cart:refresh', 'cart:updated', 'theme:cart:change'];
    events.forEach(eventName => {
      document.dispatchEvent(new CustomEvent(eventName, { bubbles: true }));
    });

    // Force reload cart sections
    if (document.querySelector('cart-drawer')) {
      document.querySelector('cart-drawer').classList.add('is-updating');
      setTimeout(() => {
        document.querySelector('cart-drawer')?.classList.remove('is-updating');
      }, 50);
    }
  }

  async freeGiftUpdate(cart) {
    if (!this.variantId || !this.threshold || this.isProcessing) return;

    const eligibleTotal = this.calculateEligibleTotal(cart);
    
    const giftItem = cart.items.find(
      (item) =>
        item.variant_id === this.variantId &&
        (item.properties?._free_gift === true || item.properties?._free_gift === 'true')
    );

    const shouldHaveGift = eligibleTotal >= this.threshold;

    console.log(`Total: ₹${(eligibleTotal/100).toFixed(2)} | Threshold: ₹${(this.threshold/100).toFixed(2)} | Has Gift: ${!!giftItem}`);

    // ADD gift if needed
    if (shouldHaveGift && !giftItem) {
      console.log('Adding gift NOW');
      await this.addProduct();
      return;
    }

    // REMOVE gift if needed
    if (!shouldHaveGift && giftItem) {
      console.log('Removing gift NOW');
      await this.removeProduct(giftItem.key);
      return;
    }

    console.log('No change needed');
  }

  async handleCartChange() {
    try {
      const cart = await this.fetchCart();
      await this.freeGiftUpdate(cart);
    } catch (e) {
      console.error('Update error:', e);
    }
  }

  async init() {
    console.log(` Free Gift Active | Variant: ${this.variantId} | Threshold: ₹${this.threshold/100}`);

    const cart = await this.fetchCart();
    await this.freeGiftUpdate(cart);

    // INSTANT listeners - no debounce
    document.addEventListener('cart:updated', () => this.handleCartChange());
    document.addEventListener('cart:refresh', (e) => {
      if (e.detail?.source !== 'free-gift-manager') {
        this.handleCartChange();
      }
    });

    // Watch cart changes in real-time
    const observer = new MutationObserver(() => this.handleCartChange());
    const cartDrawer = document.querySelector('cart-drawer, cart-notification, #cart-drawer');
    if (cartDrawer) {
      observer.observe(cartDrawer, { childList: true, subtree: true });
    }

    console.log('✅ Free Gift Manager Ready');
  }
}

// INSTANT initialization
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.freeGiftPromo = new AddFreeProduct();
  });
} else {
  window.freeGiftPromo = new AddFreeProduct();
}